
export const donutChartThemeColorHelper = donutChartThemeColors => {
  const donutChartColors = {}
  Object.keys(donutChartThemeColors).forEach(key => {
    const unittype = key
    if (unittype.startsWith('0 Bedroom')) {
      if (!donutChartColors.hasOwnProperty('Studio')) {
        donutChartColors.Studio = { }
      }
      donutChartColors.Studio[key] = donutChartThemeColors[key]
    } else if (unittype.startsWith('1 Bedroom')) {
        if (!donutChartColors.hasOwnProperty('One Bedroom')) {
          donutChartColors['One Bedroom'] = { }
        }
        donutChartColors['One Bedroom'][key] = donutChartThemeColors[key]
    } else if (unittype.startsWith('2 Bedroom')) {
        if (!donutChartColors.hasOwnProperty('Two Bedroom')) {
          donutChartColors['Two Bedroom'] = { }
        }
        donutChartColors['Two Bedroom'][key] = donutChartThemeColors[key]
    } else if (unittype.startsWith('3 Bedroom')) {
        if (!donutChartColors.hasOwnProperty('Three Bedroom')) {
          donutChartColors['Three Bedroom'] = { }
        }
        donutChartColors['Three Bedroom'][key] = donutChartThemeColors[key]
    } else if (unittype.startsWith('4 Bedroom')) {
        if (!donutChartColors.hasOwnProperty('Four Bedroom')) {
          donutChartColors['Four Bedroom'] = { }
        }
        donutChartColors['Four Bedroom'][key] = donutChartThemeColors[key]
    } else if (unittype.startsWith('5 Bedroom')) {
        if (!donutChartColors.hasOwnProperty('Five Bedroom')) {
          donutChartColors['Five Bedroom'] = { }
        }
        donutChartColors['Five Bedroom'][key] = donutChartThemeColors[key]
    } else if (unittype.startsWith('6 Bedroom')) {
      if (!donutChartColors.hasOwnProperty('Six Bedroom')) {
        donutChartColors['Six Bedroom'] = { }
      }
      donutChartColors['Six Bedroom'][key] = donutChartThemeColors[key]
    } else if (unittype.startsWith('7 Bedroom')) {
      if (!donutChartColors.hasOwnProperty('Seven Bedroom')) {
        donutChartColors['Seven Bedroom'] = { }
      }
      donutChartColors['Seven Bedroom'][key] = donutChartThemeColors[key]
    } else if (unittype.startsWith('8 Bedroom')) {
      if (!donutChartColors.hasOwnProperty('Eight Bedroom')) {
        donutChartColors['Eight Bedroom'] = { }
      }
      donutChartColors['Eight Bedroom'][key] = donutChartThemeColors[key]
    }
  })

    return donutChartColors
}
